import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const FooterContainer = styled.footer`
  background: ${props => props.theme.colors.footer};
  padding: 60px 20px;
  margin-top: auto;
`;

const FooterContent = styled.div`
  max-width: ${props => props.theme.sizes.maxWidth};
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
`;

const FooterSection = styled.div`
  h3 {
    color: ${props => props.theme.colors.primary};
    margin-bottom: 20px;
    font-size: 1.2rem;
  }

  p, a {
    color: ${props => props.theme.colors.lightText};
    line-height: 1.6;
    margin-bottom: 10px;
    text-decoration: none;
    display: block;
  }

  a:hover {
    color: ${props => props.theme.colors.primary};
  }
`;

const TimeInfo = styled.div`
  color: ${props => props.theme.colors.lightText};
  line-height: 1.8;
  
  .time-row {
    display: grid;
    grid-template-columns: 65px 1fr;
    align-items: baseline;
    gap: 5px;
  }

  .day {
    font-weight: 500;
  }
`;

const Copyright = styled.div`
  text-align: center;
  color: ${props => props.theme.colors.lightText};
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid ${props => props.theme.colors.border};
`;

function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <FooterContainer>
      <FooterContent>
        <FooterSection>
          <h3>서울쥬니어치과</h3>
          <p>대표 : 장준혁</p>
          <p>주소 : 경기도 이천시 중리천로 76 라온팰리스 2층</p>
          <p>사업자등록번호 : 139-91-00529</p>
          <p>전화번호 : 031-636-3360</p>
        </FooterSection>

        <FooterSection>
          <h3>진료시간</h3>
          <TimeInfo>
            <div className="time-row">
              <span className="day">평일</span>
              <span>09:30 - 18:30 (점심시간 13:00 - 14:00)</span>
            </div>
            <div className="time-row">
              <span className="day">토요일</span>
              <span>09:30 - 14:00 (점심시간 없음)</span>
            </div>
            <div className="time-row">
              <span className="day">공휴일</span>
              <span>휴진</span>
            </div>
          </TimeInfo>
        </FooterSection>

        <FooterSection>
          <h3>치과소개</h3>
          <Link to="/staff" onClick={scrollToTop}>의료진 소개</Link>
          <Link to="/gallery" onClick={scrollToTop}>치과 둘러보기</Link>
          <Link to="/location" onClick={scrollToTop}>오시는 길</Link>
          <Link to="/notice" onClick={scrollToTop}>공지사항</Link>
        </FooterSection>
      </FooterContent>

      <Copyright>
        © 2024 서울쥬니어치과. All rights reserved.
      </Copyright>
    </FooterContainer>
  );
}

export default Footer; 